import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center text-center px-4">
      <h1 className="text-8xl md:text-[10rem] font-heading text-primary-200 select-none pointer-events-none">
        404
      </h1>
      <div className="relative -mt-8">
        <h2 className="text-xl md:text-2xl font-semibold text-foreground-800">页面未找到</h2>
        <p className="mt-2 text-sm text-foreground-500">
          当前路径：{location.pathname}
        </p>
        <p className="mt-1 text-sm text-foreground-400">
          该页面还未生成，请确认链接是否正确
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}